export default __webpack_public_path__ + "static/media/drifting_active.a2d35ea7.svg";